/**
 * WordPress dependencies
 */

import {
  useBlockProps,
  InspectorControls,
  RichText,
} from '@wordpress/block-editor';
import { PanelBody, SelectControl, RadioControl } from '@wordpress/components';
import React from 'react';
import { _x } from '@wordpress/i18n';

const Edit = (props) => {
  const {
    attributes: {
      headingTitle,
      headingTitle2,
      headingLabel,
      blocHeadingIcon,
      textAlign,
      textSize,
    },
    setAttributes,
  } = props;

  const blockProps = useBlockProps({
    className: 'theme-block theme-block--innerblock-wrapper heading-with-label',
  });

  const iconOptions = [
    {
      label: _x('No Icon', 'Heading block select control option', 'vtx'),
      value: '',
    },
    {
      label: _x('Smile 1', 'Heading block select control option', 'vtx'),
      value: 'smile',
    },
    {
      label: _x('Smile 2', 'Heading block select control option', 'vtx'),
      value: 'smile2',
    },
    {
      label: _x('Stars', 'Heading block select control option', 'vtx'),
      value: 'star',
    },
    {
      label: _x('Heart', 'Heading block select control option', 'vtx'),
      value: 'heart',
    },
  ];

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={_x('Heading block settings', 'Panel title', 'vtx')}>
          <RadioControl
            label={_x('Text Alignment', 'Radio control label', 'vtx')}
            selected={textAlign}
            options={[
              {
                label: _x('Left', 'Radio control option', 'vtx'),
                value: 'left',
              },
              {
                label: _x('Center', 'Radio control option', 'vtx'),
                value: 'center',
              },
            ]}
            onChange={(newAlign) => setAttributes({ textAlign: newAlign })}
          />

          <RadioControl
            label={_x('Text Size', 'Radio control label', 'vtx')}
            selected={textSize}
            options={[
              {
                label: _x('default', 'Radio control option', 'vtx'),
                value: 'default',
              },
              {
                label: _x('Large', 'Radio control option', 'vtx'),
                value: 'large',
              },
            ]}
            onChange={(newSize) => setAttributes({ textSize: newSize })}
          />

          <SelectControl
            label={_x('Select Icon', 'Select control label', 'vtx')}
            value={blocHeadingIcon}
            options={iconOptions}
            onChange={(newIcon) => setAttributes({ blocHeadingIcon: newIcon })}
          />
        </PanelBody>
      </InspectorControls>
      <div className="heading-with-label__label-wrapper">
        <span className="theme-block__label">
          {_x('Heading block', 'admin block label', 'vtx')}
        </span>
        <div className="greenux-label">
          <span className="icon icon-fleur"></span>
          <RichText
            tagName="p"
            className="greenux-label__text"
            onChange={(newLabel) => setAttributes({ headingLabel: newLabel })}
            value={headingLabel}
            placeholder={_x(
              'Enter label here',
              'admin block input placeholder',
              'vtx'
            )}
          />
        </div>
      </div>
      <RichText
        tagName="h2"
        className="heading-title"
        onChange={(newTitle) => setAttributes({ headingTitle: newTitle })}
        value={headingTitle}
        placeholder={_x(
          'Enter title here',
          'admin block input placeholder',
          'vtx'
        )}
      />
      <RichText
        tagName="h2"
        className="heading-title-span"
        onChange={(newTitle2) => setAttributes({ headingTitle2: newTitle2 })}
        value={headingTitle2}
        placeholder={_x(
          'Enter title2 here',
          'admin block input placeholder',
          'vtx'
        )}
      />
    </div>
  );
};
export default Edit;
